import { useEffect } from 'react';

import { Logger } from '../../Logging';
import type { StatsigClient } from '../StatsigLib';
import type { RoverStatsigUser } from '../types';
import { createUserPayload, userNeedsUpdate } from '../utils';

/**
 * Hook that handles automatic user updates for a Statsig client.
 * Watches for changes to roverStatsigUser and calls updateUserAsync when needed.
 * through the magic of React context all usages of Statsig hooks will update after this
 * MAYBE FUTURE TODO: this fires a bit more than it really needs to but it doesn't _seem_ to hurt anything? This happens because:
    - sometimes roverStatsigUser is an empty object, which we now handle below
    - the userNeedsUpdate() function doesn't account well for keys being defined in the the old data but not in the new
 */
export function useStatsigUserUpdates(
  client: StatsigClient | null,
  roverStatsigUser: RoverStatsigUser
): void {
  useEffect(() => {
    if (
      client &&
      client.getContext().user &&
      roverStatsigUser &&
      // check that roverStatsigUser is not all undefined values
      Object.values(roverStatsigUser).some((value) => value !== undefined) &&
      userNeedsUpdate(client.getContext().user, roverStatsigUser)
    ) {
      client
        .updateUserAsync(createUserPayload(roverStatsigUser, client.getContext().user))
        .catch((error) => {
          Logger.error(error);
        });
    }
  }, [client, roverStatsigUser]);
}
